import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import LoginRegistration from "pages/login-registration";
import UserDashboard from "pages/user-dashboard";
import RealTimeCustomerSupport from "pages/real-time-customer-support";
import PaymentProcessing from "pages/payment-processing";
import SocialMediaAnalyticsDashboard from "pages/social-media-analytics-dashboard";
import AdminPackageManagement from "pages/admin-package-management";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<UserDashboard />} />
        <Route path="/login-registration" element={<LoginRegistration />} />
        <Route path="/user-dashboard" element={<UserDashboard />} />
        <Route path="/real-time-customer-support" element={<RealTimeCustomerSupport />} />
        <Route path="/payment-processing" element={<PaymentProcessing />} />
        <Route path="/social-media-analytics-dashboard" element={<SocialMediaAnalyticsDashboard />} />
        <Route path="/admin-package-management" element={<AdminPackageManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;